module.exports = __webpack_public_path__ + "img/NobleLogin.dfafa76c.png";